var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.body",
          value: _vm.loading,
          expression: "loading",
          modifiers: { body: true },
        },
      ],
      staticClass: "app-container",
      attrs: { "element-loading-text": "加载中..." },
    },
    [
      _c(
        "el-card",
        {
          staticClass: "sticky-container",
          attrs: { shadow: "never", "body-style": { padding: 0 } },
        },
        [
          _c(
            "template",
            { slot: "header" },
            [
              _c("order-search", {
                attrs: {
                  params: _vm.queryParams,
                  suppliers: _vm.suppliers,
                  "order-count": _vm.orderCount,
                },
                on: {
                  "update:params": function ($event) {
                    _vm.queryParams = $event
                  },
                  filter: _vm.handleFilter,
                  import: _vm.handleImport,
                },
              }),
            ],
            1
          ),
          _c("order-table", {
            attrs: { params: _vm.queryParams, list: _vm.list },
          }),
          _c("pagination", {
            attrs: {
              total: _vm.total,
              page: _vm.queryParams.page,
              limit: _vm.queryParams.limit,
            },
            on: {
              "update:page": function ($event) {
                return _vm.$set(_vm.queryParams, "page", $event)
              },
              "update:limit": function ($event) {
                return _vm.$set(_vm.queryParams, "limit", $event)
              },
              pagination: _vm.fetchData,
            },
          }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }